<div class="generate-actuary-report-container">
  <ptg-breadcrumb
    [listBreadcrumbs]="listBreadcrumbs"
  ></ptg-breadcrumb>

  <div class="generate-actuary-report-section flex flex-col p-6">
    <form [formGroup]="editForm" (ngSubmit)="formSubmit$.next()" class="flex flex-col gap-4">
      <div class="flex date-field-section gap-x-4">
        <ptg-datepicker
          [controlField]="editForm.get('startDate')"
          placeholder="Period Start Date"
          [isRequired]="true"
          (changeValue)="controlDate()"
          customError="customStartDateError"
        ></ptg-datepicker>
        <ptg-datepicker
          [controlField]="editForm.get('endDate')"
          placeholder="Period End Date"
          [isRequired]="true"
          (changeValue)="controlDate()"
          customError="customEndDateError"
        ></ptg-datepicker>
      </div>
      <div class="flex">
        <ptg-button
          classInput="primary"
          buttonName="Generate Report"
          type="submit"
          class="generate-button"
          [isDisabled]="isGenerateLoading"
        >
          <mat-icon class="material-icons-round">download</mat-icon>
        </ptg-button>
      </div>
    </form>
    <div class="flex-grow overflow-hidden generate-letters-section mt-12">
      <div class="header">
        <span class="title font-bold">Generated Reports</span>
      </div>
      <ptg-grid
        [data]="tableData"
        [isLoading]="isTableLoading"
        [columns]="columns"
        [pageSize]="pageSize"
        [pageNumber]="pageIndex"
        [totalRecords]="totalRecords"
        (pageChange)="onChangePage($event)"
        (sortChange)="onSortChange($event)"
        [fitToParent]="true"
        notFoundMessage="No Data to Display"
      >
        <ng-template cellContent columnName="fileName" let-row>
          <div class="flex file-document-container">
            <span stopPropagation (click)="downloadLetter(row)" class="file-document-name" target="_blank">
              <span class="truncate">{{ row?.fileName || '' }}</span>
            </span>
          </div>
        </ng-template>
      </ptg-grid>
    </div>
  </div>
</div>
